import { sendPost } from '@utils/request';
import './order';
import './address';
import './logistics';
import './health';
import { unionFlag } from '@/utils';

export function getDetailData(data) {
  const url = '/trade/goods/findGoodsDetails';
  return sendPost({ url, data });
}

export function getUserMenuListBFD(data) {
  const url = '/user/menu/list';
  return sendPost({ url, data, baseURL: false, applicationType: false });
}

// 根据地址 skuid 获取 商品库存信息
export function getStockStatus(data) {
  const url = '/api/web/stock';
  return sendPost({ url, data });
}
// 获取商品信息
export function getProductInfo(data) {
  const url = '/trade/goods/findGoodsDetails';
  return sendPost({ url, data });
}

// Fill and Double Check Delivery Info
export function fetchFindByUnion(data) {
  const url = '/mallUnion/unionConfig/findByUnion';
  return sendPost({ url, data, Business: false });
}

// 获取union头部数据
export function fetchUnionLogo(data) {
  const url = '/mallunion/getLogo';
  return sendPost({ url, data, baseURL: false, applicationType: false });
}

export function fetchLifeIndex(data) {
  const url = '/trade/preferredLifeContract/getHomePageData';
  return sendPost({ url, data });
}

//首页左侧分类
export const getHomeCategoryList = async (data) => {
  const url = '/categoryGoods/getChannelCategory';
  return sendPost({ url, data });
};

//分类商品
export const getHomeCategoryProducts = async (data) => {
  const url = '/categoryGoods/getCategoryGoodsOptimize';
  return sendPost({ url, data });
};

export function fetchProductListById(data) {
  const url = '/categoryGoods/getCategoryGoodsList';
  return sendPost({ url, data });
}

export function promotionGoods(data) {
  const url = '/api/promotion/goods/detail';
  return sendPost({ url, data });
}
export function getAds(data) {
  const url = '/api/ads/banner/getBanner';
  return sendPost({ url, data });
}

export function getBookAds(data) {
  const url = '/api/ads/banner/getBannerInfo';
  return sendPost({ url, data });
}

export function fetchAddList(data) {
  const url = '/categoryGoods/additionGoodsList';
  return sendPost({ url, data });
}

export function fetchRecentScan(data) {
  const url = '/trade/goods/recentlyViewed';
  return sendPost({ url, data });
}

export function fetchNavCategory(data) {
  const url = '/trade/index/getAllCategoryByChannel';
  return sendPost({ url, data });
}
export function fetchUnionScale(data) {
  const url = '/union/getunionconfig';
  return sendPost({ url, data, baseURL: false, applicationType: false });
}

// 获取工会菜单
export function getFindUsableList(data) {
  const url = '/mallUnion/unionMallConfig/findUsableList';
  return sendPost({ url, data });
}

export function getLogo(data) {
  const url = '/mallunion/getLogo';
  return sendPost({ url, data, baseURL: false, applicationType: false });
}
// 获取商品标签
export function fetchGoodsTags(data) {
  const unionF = unionFlag() || sessionStorage.getItem('dffl_union');
  if (window.df_sdk_common.isBfd())
    data.unionId = unionF;
  const url = '/trade/promotion/tags';
  return sendPost({ url, data });
}

export function doValidate() {
  const url = '/oms/right/gray/validate';
  return sendPost({
    url, data: {
      tagId: 200001,
      appCode: '100020',
    }, baseURL: true, applicationType: true,
  });
}



export function groductShare(data) {
  const url = '/trade/productShare';
  return sendPost({ url, data });
}

/* 百福得新聚合接口
*/
export const getCompanyConfig = () => {
  const url = '/companydata/front/platform/getCompanyConfig';
  return sendPost({ url, data: {}, bfdURL: true, method: 'get' });;
};
